import axios, {
  AxiosResponse,
  HttpStatusCode,
  InternalAxiosRequestConfig,
} from "axios";
import { onUnauthorized } from "../util/JsInterfaceUtil";
import { isAppResponse } from "../util/RequestUtil";
import { AppError } from "../entity/BaseApi";
import { getCookie } from "cookies-next";

export const TOKEN =
  "" +
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9kZS1nZW5raS5nZW5raW1pcnUuanBcL2FwaVwvdjFcL2xvZ2luIiwiaWF0IjoxNjg3MjI5MDkzLCJleHAiOjE2ODk4MjEwOTMsIm5iZiI6MTY4NzIyOTA5MywianRpIjoiTGxYRUE0TFZVTHBMeXpoZyIsInN1YiI6MzQ5NCwicHJ2IjoiYzhlZTFmYzg5ZTc3NWVjNGM3Mzg2NjdlNWJlMTdhNTkwYjZkNDBmYyJ9.vs5nX_piWBwV_5hbDCJmqARm_w-YTS7iIqbGT17GIfc";

const BASE_URL_DEV = "https://de-genki.genkimiru.jp/api/v1/";
const BASE_URL_STG = "https://st-genki.genkimiru.jp/api/v1/";
const BASE_URL_PRO = "https://api.genkimiru.jp/api/v1/";

const axiosClient = axios.create({
  baseURL: BASE_URL_PRO,
  headers: {
    "Content-Type": "application/json",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    // token: TOKEN,
    token: getCookie("token"),
  },
});

// Add a request interceptor
axiosClient.interceptors.request.use(
  function (value: InternalAxiosRequestConfig<any>) {
    // Do something before request is sent
    return value;
  },

  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosClient.interceptors.response.use(
  function (response: AxiosResponse) {
    // pp("axiosClient.interceptors.response.success()");
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const resData = response.data;

    if (isAppResponse(resData)) {
      const { status, body } = resData;
      if (status !== HttpStatusCode.Ok) {
        const bodyError = body as unknown as string[];
        const errorCode = bodyError[0];
        const appError: AppError = {
          errorCode: errorCode,
          errorCodes: bodyError,
        };
        // console.log(appError);
        return Promise.reject(appError);
      }
    }
    // return resData;
    return response;
  },
  function (error) {
    // pp("axiosClient.interceptors.response.error()");
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error?.response?.status === HttpStatusCode.Unauthorized) {
      onUnauthorized();
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
